import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap'
import Select from 'react-select'
import { FaCog } from 'react-icons/fa'
import { ContactCard } from './ContactCard'
import s from './FollowupModal.scss'
import { Spinner } from 'components/ideal-core-ui'

const FollowupModal = ({
  showFollowupModal,
  toggleFollowupModal,
  deals,
  removeDeal,
  allContactsSelected,
  setAllContactsSelected,
  template,
  templates,
  changeTemplate,
  getFollowupData,
  contacts,
  removeContact,
  isLoading,
  toggleContactDeal,
  setContactFollowUpDate,
  setContactEmailSubject,
  setContactEmailFiles,
  removeFile,
  setContactEmailTemplate,
  setContactEmailTemplateBody,
  sendIndividualEmail,
  setFollowupDate,
  users,
  setCCContacts
}) => {
  const [cardsOpen, setCardsOpen] = useState(true)
  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={showFollowupModal}
      toggle={() => {
        window.tinymce &&
          window.tinymce.get().forEach(editor => {
            editor.off('NodeChange')
          })
        toggleFollowupModal()
      }}
      size="xl"
      className={s.modal}
    >
      <ModalHeader
        toggle={() => {
          window.tinymce &&
            window.tinymce.get().forEach(editor => {
              editor.off('NodeChange')
            })
          toggleFollowupModal()
        }}
        className={s.modalHeader}
      >
        Follow-up by Email
      </ModalHeader>
      <ModalBody>
        <div className={s.header}>
          <p>You selected to follow-up on the following opportunities</p>
          <ul className={s.selectedDealsContainer}>
            {deals.map(deal => (
              <li key={deal.id}>
                <span className={s.deal}>{deal.name}</span>
                <span className={s.removeDeal} onClick={() => removeDeal(deal.id)}>
                  &times;
                </span>
              </li>
            ))}
          </ul>
          <div className={s.actions}>
            <label className={s.radioContainer}>
              <input
                type="radio"
                checked={!allContactsSelected}
                onChange={() => setAllContactsSelected(false)}
              />{' '}
              Email Main Contact(s)
            </label>
            <label className={s.radioContainer}>
              <input
                type="radio"
                checked={allContactsSelected}
                onChange={() => setAllContactsSelected(true)}
              />{' '}
              Email All Contact(s) attached to above deals
            </label>
            <Button disabled={isLoading} className={s.greenBtn} onClick={getFollowupData}>
              <FaCog />
              Run Follow-up List
            </Button>
          </div>
        </div>
        {isLoading ? (
          <Spinner className={s.spinner} />
        ) : contacts.length ? (
          <div className={s.main}>
            <div className={s.actions}>
              <div className={s.cardControls}>
                <span onClick={() => setCardsOpen(true)}>Expand All</span>
                <span onClick={() => setCardsOpen(false)}>Collapse All</span>
              </div>
              <div className={s.templateSelectContainer}>
                <span>Email Template:</span>
                <Select
                  value={template}
                  onChange={changeTemplate}
                  options={templates}
                  className={s.templateSelect}
                  placeholder="Select Email Template"
                  isDisabled={!contacts.length}
                />
              </div>
            </div>
            {contacts.map((contact, index) => (
              <ContactCard
                key={`${contact.contactEmail}-${contact.contactId}`}
                contact={contact}
                index={index}
                cardsOpen={cardsOpen}
                removeContact={removeContact}
                templates={templates}
                toggleContactDeal={toggleContactDeal}
                setContactFollowUpDate={setContactFollowUpDate}
                setContactEmailSubject={setContactEmailSubject}
                setContactEmailFiles={setContactEmailFiles}
                removeFile={removeFile}
                setContactEmailTemplate={setContactEmailTemplate}
                setContactEmailTemplateBody={setContactEmailTemplateBody}
                sendIndividualEmail={sendIndividualEmail}
                setFollowupDate={setFollowupDate}
                users={users}
                setCCContacts={setCCContacts}
              />
            ))}
          </div>
        ) : (
          <p className={s.noContacts}>No contacts</p>
        )}
      </ModalBody>
    </Modal>
  )
}

export default FollowupModal
